import { render, staticRenderFns } from "./OnetimeRegisterComplete.vue?vue&type=template&id=b675ea74&scoped=true"
import script from "./OnetimeRegisterComplete.vue?vue&type=script&lang=js"
export * from "./OnetimeRegisterComplete.vue?vue&type=script&lang=js"
import style0 from "./OnetimeRegisterComplete.vue?vue&type=style&index=0&id=b675ea74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b675ea74",
  null
  
)

export default component.exports